import { type SourceAnalysisOrganizerFormData } from "@/types/models/Exportables.interface";
import { AdjustFontSizeToFitContent } from "@/view/utils/useAdjustFontSizeToFitContent";
import {
  guideCell,
  guideRow,
  textareaCss,
} from "./SourceAnalysisOrganizer.styles";

interface SourceAnalysisRowProps {
  field: keyof SourceAnalysisOrganizerFormData;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  templateId: string;
  value: string | number;
}

const CUSTOM_INPUT_MAX_LENGTH = 134;

const SourceAnalysisRow = ({
  field,
  label,
  onChange,
  templateId,
  value,
}: SourceAnalysisRowProps) => {
  const fieldName = field.toLowerCase().replace(/_\s/g, "-");
  const id = `${fieldName}-${templateId}`;
  const qaSelector = `exportables-source-analysis-${fieldName}`;
  const trimmedValue = `${value}`.substring(0, CUSTOM_INPUT_MAX_LENGTH) ?? "";

  return (
    <div css={guideRow}>
      <div css={guideCell}>
        <AdjustFontSizeToFitContent deps={[label]}>
          <label htmlFor={id}>{label}</label>
        </AdjustFontSizeToFitContent>
      </div>

      <div css={guideCell}>
        <AdjustFontSizeToFitContent deps={[trimmedValue]}>
          <textarea
            id={id}
            css={textareaCss}
            data-qa-selector={qaSelector}
            maxLength={CUSTOM_INPUT_MAX_LENGTH}
            onChange={onChange}
            value={trimmedValue}
          />
        </AdjustFontSizeToFitContent>
      </div>
    </div>
  );
};

export default SourceAnalysisRow;
